
<div
  class="get-in-touch transition"
  (click)="checkMobileNumber()"
  *ngIf="testPopup"
  data-toggle="modal" 
  data-target="#autoload"
>
  get in touch
</div>
<div class="header-fixed transition">
  <!--top strip start here-->
  <div class="top-strip">
    <div class="col-md-11">
      <ul class="list list-inline">
        <li>
          <a  (click)="openPhoneNumber()" class="bookfreeDemo transition"
            ><img class="hl-img" src="assets/images/hotline.png" alt=""> (0)2039808244</a
          >
        </li>
        <li>
          <a href="https://zfrmz.in/rsyoypG8JC7NYwLd1Plz" class="bookfreeDemo transition"
            >Book Free Webinar
          </a>
        </li>
      </ul>
    </div>
    <div class="col-md-1">
      <ul class="list list-inline footer-socials">
        <li>
          <a
            href="{{ siteSetting?.social_telegram_url }}"
            target="_blank"
            class="fb btn-hover"
            ><i class="fa fa-paper-plane" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a
            href="{{ siteSetting?.social_facebook_url }}"
            target="_blank"
            class="fb btn-hover"
            ><i class="fa fa-facebook" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a
            href="{{ siteSetting?.social_twitter_url }}"
            target="_blank"
            class="tw btn-hover"
            ><i class="fa fa-twitter" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a
            href="{{ siteSetting?.social_linkedin_url }}"
            target="_blank"
            class="linkdin btn-hover"
            ><i class="fa fa-linkedin" aria-hidden="true"></i
          ></a>
        </li>
      </ul>
    </div>
  </div>
  <!--top strip ends here-->

  <!--header start here-->
  <header>
    <div class="container-fluid">
      <div class="col-md-3">
        <a [routerLink]="['/']"
          ><img src="assets/images/logo-w.png" class="logo transition"
        /></a>
      </div>
      <div class="col-md-7 static padding0">
        <div class="nav-icon1 open-nav">
          <span></span><span></span><span></span>
        </div>
        <nav class="transition static">
          <div class="nav-icon1 open close-nav">
            <span></span><span></span><span></span>
          </div>
          <ul class="static">
            <li><a class="links" [routerLink]="['/']">Home</a></li>

            <!-- 11plus offers -->
            <li class="mega-menu-wrap tab">
              <a class="cursor" style="text-transform: capitalize"
                >11+<i class="fa fa-angle-down" aria-hidden="true"></i
              ></a>
              <ul class="submenu mega-menu">
                <li class="col col2">
                  <h3>11+ Overview</h3>
                  <ol>
                    <li>
                      <a class="links" [routerLink]="['/w11plus']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        What is 11+?
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/fsce-11-plus-exam-overview']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        FSCE 11+ Overview
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/consortium']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Consortiums
                      </a>
                    </li>
                    <li>
                      <a class="links" [routerLink]="['/key-dates']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Key Dates
                      </a>
                    </li>
                    <li>
                      <a class="links" [routerLink]="['/grammar-schools']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        Grammar Schools
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/private-schools']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        Top Private Schools
                      </a>
                    </li>

                    

                  </ol>
                </li>

                <li class="col col2">
                  <h3>11+ Mocks</h3>
                  <ol>
                    <li>
                      <a class="links" [routerLink]="['/11plus-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >11+ Mock Test</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-topic-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >11+ Topic Test</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/year-4-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >Year 4 Topic Test</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-sprint']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >11+ Sprint</span>
                      </a>
                    </li>

                   

                       <li>
                      <a class="links" [routerLink]="['/offer-free-resources']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Offers</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/question-bank']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span>11+ Exam Question Bank</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/locations']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >Mock Test Locations</span>
                      </a>
                    </li>
                    
                  
                  </ol>
                </li>

                 <li class="col col3">
                  <h3>Tuition</h3>
                  <ol>

                     <li>
                      <a class="links" [routerLink]="['/11plus-course-pricing']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Course Pricings</span>
                      </a>
                    </li>


                   <li>
                      <a class="links" [routerLink]="['/11Plus-classes']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">Join 11+ Classes</span>
                      </a>
                    </li>


                     <li>
                      <a class="links" [routerLink]="['/11plus-admission']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >11+ Admissions</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/webinar']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >11+ Webinar</span>
                      </a>
                    </li>

                     <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span>11+ Upcoming Sessions</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-HelpClub']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ HelpClub (Free)</span>
                      </a>
                    </li>

                     <li>
                      <a class="links" [routerLink]="['/free-resources']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Free Resources</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/digital-download']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Digital Download</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/free-assessment']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Free Assessment</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-assessment']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Pre Admission Assessment</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-course-pricing']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">11+ Course Pricings</span>
                      </a>
                    </li>


                  </ol>
                </li>

                <li class="col col3">
                  <h3 class="hlight">Summer Courses</h3>
                  <ol>


                    <li>
                      <a class="links" [routerLink]="['11plus-summer-intensive']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                         <span class="hlight">11+ Intensive Course (All Subjects)</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/11plus-summer-bootcamp']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                         <span class="hlight">11+ Summer Bootcamp Courses</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/b618fddc1bce2f1a22d8584688f52fea">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Intensive Course Maths
                      </a>
                    </li>

                    <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/c4f75dea69f3aa757f1c8fce778e5100">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Intensive Course NVR & Spatial Reasoning
                      </a>
                    </li>

                    <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/4c53fff4c24e8b1043f456b92ea0b09e">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Revision | English + Reading Comprehension & Creative Writing
                      </a>
                    </li>

                    <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/3e5cd97221c44397a12a18ae2433ddcf">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Revision | Verbal Reasoning
                      </a>
                    </li>


                    <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/e8457c5d910d99ff24ab8036930c6b84">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Revision | Reading Comprehension
                      </a>
                    </li>
                  </ol>
                </li>

                <li class="col col3">
                  <h3>Special Courses</h3>
                  <ol>
                     <li>
                      <a class="links" [routerLink]="['/rapid-course']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        11+ Intensive Course
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/creative-writing']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        Creative Writing Course
                      </a>
                    </li>
                    <li>
                      <a class="links" [routerLink]="['/spag-course']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        SPaG Rapid Course
                      </a>
                    </li>
                    <li>
                      <a class="links" [routerLink]="['/bridge-courses']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <Span class="hlight">11+ Bridge Course(Y4-Y5)</Span>
                      </a>
                    </li>
                    
                  </ol>
                </li>

                
              </ul>
            </li>


            <!-- GCSE Menu-->
            <li class="mega-menu-wrap tab">
              <a class="cursor" style="text-transform: capitalize"
                >GCSE<i class="fa fa-angle-down" aria-hidden="true"></i></a>
              <ul class="submenu mega-menu">
                

                <li class="col col2">
                  <h3>GCSE Mocks</h3>
                  <ol>
                    <li>
                      <a class="links" [routerLink]="['/gcse-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span> GCSE Full Mock Test</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/year-10-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span> Year 10 GCSE Mock Test</span>
                      </a>
                    </li>

                     <li>
                      <a class="links" [routerLink]="['/gcse-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span> GCSE Mini Mock Test</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/ks3-mock-test']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span> KS-3 Mock Tests</span>
                      </a>
                    </li>

                      <li>
                      <a class="links" [routerLink]="['/offer-free-resources']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">GCSE Offers</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/location']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span>Mock Test Locations</span>
                      </a>
                    </li>
                    
                       <li>
                      <a class="links" [routerLink]="['/gcse-help-club']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span>GCSE HELP CLUB(YEAR 9) </span>
                      </a>
                    </li>
                    
                  </ol>
                </li>

                 <li class="col col3">
                  <h3>Tuition</h3>
                  <ol>
                    
                    <li>
                      <a class="links" [routerLink]="['/gcse-classes']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">Join GCSE Classes</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/gcse-admission']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span class="hlight">GCSE Admissions</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/admission-open']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >Admissions</span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/webinar']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span >Webinar</span>
                      </a>
                    </li>

                     <li>
                      <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <span>Upcoming Sessions</span>
                      </a>
                    </li>

                  </ol>
                </li>


                <li class="col col3">
                  <h3>Special Courses</h3>
                  <ol>

                    <li>
                      <a class="links" [routerLink]="['/python-course']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <Span class="hlight">Python Adventures</Span>
                      </a>
                    </li>

                    <li>
                      <a class="links" [routerLink]="['/gcse-summer-bootcamp']">
                        <i class="fa fa-caret-right" aria-hidden="true"></i>
                        <Span class="hlight">GCSE Summer Bootcamp</Span>
                      </a>
                    </li>

                  </ol>
                </li>

                
              </ul>
            </li>

            <!-- A Level -->

            <li class="sub-menu-wrap">
              <a class="cursor"
                >A-Level <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>
              <ul class="submenu submenu-sml">

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >AS-Level Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >A-Level Tuition</a
                  >
                </li>

                 <li>
                  <a class="links" href="https://www.sehyog.co.uk/11plus-help-club/category">Upcomming Sessions</a>
                </li>

                <li>
                  <a class="links" [routerLink]="['/webinar']">Webinar</a>
                </li>
            

                <li>
                  <a class="links" [routerLink]="['/admission-open']"
                    >Admissions</a
                  >
                </li>
                
              </ul>
            </li>
            

            <!-- Tuition menu starts here -->

            <li class="sub-menu-wrap">
              <a class="cursor"
                >Tuition<i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>
              <ul class="submenu submenu-sml">

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >Early Year Tuition</a>
                </li>

                <li>
                  <a class="links" [routerLink]="['/11Plus-classes']"
                    >11+ Tuition</a
                  >
                </li>
                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >12+ Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >13+ Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >KS3 Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/gcse-classes']"
                    >GCSE Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >AS-Level Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >A-Level Tuition</a
                  >
                </li>

                <li>
                  <a class="links" [routerLink]="['/freedemo']"
                    >SATs Tuition</a
                  >
                </li>

                <!-- <li><a class="links" [routerLink]="['/sehyog/photo-gallery']">ASA Classes</a></li> -->
              </ul>
            </li>

            <!-- Academy menu Ends here -->

            

            <!-- University Program-->
            <li class="sub-menu-wrap">
              <a class="cursor"
                >UNI. PROGRAM <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>
              <ul class="submenu submenu-sml">
                <span class="secondMenu">
                  <li><a class="links" [routerLink]="['/genAI-dataScience-program']">AI & Data Tech Courses</a></li>
                <li><a class="links" [routerLink]="['/data-science']">Data Science</a></li>

                  
                  <span class="sublist2">
                    <!-- <li><a class="links" [routerLink]="['/topic-test']">Topic Test</a></li>
                              <li><a class="links" [routerLink]="['/mock-test']">Mock Test</a></li> -->
                    <!-- <li><a class="links" [routerLink]="['/11plus-help-club/category/11-mock-test']" [queryParams]="{location: 'Southend-on-sea'}" href="#">Southend-on-sea</a></li>
                              <li><a class="links" [routerLink]="['/11plus-help-club/category/11-mock-test']" [queryParams]="{location: 'Basildon'}" href="#">Basildon</a></li>
                              <li><a class="links" [routerLink]="['/11plus-help-club/category/11-mock-test']" [queryParams]="{location: 'other'}" href="#">Others Centers & Online</a></li> -->
                  </span>
                </span>

                <span class="firstMenu">
                  <li>
                    <a class="links" >Prompt Engineering</a>
                  </li>
                  <li><a class="links" >Interview & Career Skills</a></li>
                  <li><a class="links" >How It Works / Eligibility</a></li>
                </span>
              </ul>
            </li>


            <!-- BLOGS -->
            <li>
              <a [routerLink]="['/blogs']" class="links">BLOGS</a>
            </li>


            <!-- About Us -->

            <li class="mega-menu-wrap tab">
              <a class="cursor" style="text-transform: capitalize"
                >ABOUT US<i class="fa fa-angle-down" aria-hidden="true"></i
              ></a>
              <ul class="submenu mega-menu">
            

      
                <li class="col col4">
                  <h3>About</h3>
                  <div class="clearfix"></div>
                  <ol>

                    <li>
                      <a
                        [routerLink]="['/product-services']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Product & Services</a>
                    </li>

                    <li>
                      <a
                        [routerLink]="['/sehyog/vision-mission']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Vision & Mission</a>
                    </li>
                     <li>
                      <a
                        [routerLink]="['/sehyog/team']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Team</a>
                    </li>

                    <li>
                      <a
                        [routerLink]="['/sehyog/inception-story']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Inception Story</a>
                    </li>
                    <li>
                    </li>
                  </ol>
                </li>

                <li class="col col3">
                  <h3>FAQ</h3>
                  <div class="clearfix"></div>
                  <ol>
                    <!-- <li *ngFor="let category of categories; let i = index">
                      <a
                        class="links remove-mega"
                        [routerLink]="['/11plus-help-club/faq', category.slug]"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i
                        >{{ category.faq_category }}</a
                      >
                    </li> -->

                     <li>
                      <a [routerLink]="['/faq/general-faq']" class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        General FAQ</a
                      >
                    </li>

                    <li>
                      <a [routerLink]="['//faq/parent-faq']" class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Parent/Teacher FAQ</a
                      >
                    </li>

                    <li>
                      <a [routerLink]="['/support']" class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Support Form</a
                      >
                    </li>

                  </ol>
                </li>

                <li class="col col3">
                  <h3>International</h3>
                  <div class="clearfix"></div>
                  <ol>
                    <li>
                      <a [routerLink]="['/UAE']" class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Tuition in UAE</a
                      >
                    </li>

                     <li>
                      <a [routerLink]="['/india']" class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Tuition in India</a
                      >
                    </li>
                  </ol>
                </li>


                <li class="col col4">
                  <h3>Get Inspired</h3>
                  <div class="clearfix"></div>
                  <ol>
                    <li>
                      <a
                        [routerLink]="['/11plus-help-club/get-inspired/success-stories']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Success Stories</a
                      >
                    </li>
                    <li>
                      <a
                        [routerLink]="['/11plus-help-club/get-inspired/testimonial']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Testimonial</a
                      >
                    </li>
                    <li>
                      <a
                        [routerLink]="['/sehyog/photo-gallery']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Photo Gallery</a>
                    </li>
                     <li>
                      <a
                        [routerLink]="['/sehyog/video-gallery']"
                        class="links"
                        ><i class="fa fa-caret-right" aria-hidden="true"></i>
                        Video Gallery</a>
                    </li>
                    <li></li>
                  </ol>
                </li>
                <li class="col col5">
                  <a
                    [routerLink]="['/request-for-franchise']"
                    class="btn btn-custom border btn-hover links"
                    ><img src="assets/images/handshake.svg" /> &nbsp;Request For
                    Franchise
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i
                  ></a>
                  <div class="clearfix"></div>
                  
                    <img src="assets/images/mega-menu.png" />
                </li>
               
              </ul>
            </li>


            <li>
              <a [routerLink]="['/contact-us']" class="links">Contact us</a>
            </li>
            <li *ngIf="isLoggedInUser">
              <a [routerLink]="['/basket']" class="links"
                ><i class="fa fa-shopping-basket" aria-hidden="true"></i> Basket
                ( <span class="header-basket-count">0</span> )</a
              >
            </li>
            <!-- <li *ngIf="isLoggedInUser"><a [routerLink]="['/dashboard']"  class="links"><i class="fa fa-id-badge" aria-hidden="true"></i> My Dashboard </a></li> -->
          </ul>
          <div class="clearfix"></div>
          <br />

          <ul class="list list-inline login-section" *ngIf="!isLoggedInUser">
            <li>
              <a
                [routerLink]="['/signin']"
                class="btn btn-custom border btn-hover"
                >Login <i class="fa fa-long-arrow-right" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a [routerLink]="['/signup']" class="btn btn-custom org btn-hover"
                >Sign up
                <i class="fa fa-long-arrow-right" aria-hidden="true"></i
              ></a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="col-md-2 padding0">
        <ul
          class="my-acc-drop"
          data-login="has-login"
          *ngIf="isLoggedInUser; else templateName"
        >
          <li class="dropdown" [class.open]="dropdownOpen">
  <a
    class="cursor dropdown-toggle"
    (click)="toggleDropdown()"
    aria-hidden="true"
  >
    <span class="img"
      ><i class="fa fa-user-circle-o" aria-hidden="true"></i>
    </span>
    <label class="res-hide"
      >{{ username | titlecase }}
      <i class="fa fa-angle-down" aria-hidden="true"></i
    ></label>
  </a>
  <ul class="dropdown-menu dropdown-menu-right" *ngIf="dropdownOpen">
    <li>
      <a [routerLink]="['/dashboard']" class="cursor">My Account</a>
    </li>
    <li>
      <a [routerLink]="['/dashboard/preferences']" class="cursor">
        Preferences</a
      >
    </li>
    <li><a (click)="userLogouts()">Logout</a></li>
  </ul>
</li>
        </ul>

        <ng-template #templateName>
          <ul class="list list-inline">
            <li>
              <a
                [routerLink]="['/signin']"
                class="btn btn-custom white btn-hover"
                >Login</a
              >
            </li>
            <li>
              <a [routerLink]="['/signup']" class="btn btn-custom org btn-hover"
                >Sign up</a
              >
            </li>
          </ul>
        </ng-template>
      </div>
    </div>
  </header>
  <!--header ends here-->
</div>
